import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTelevision: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTelevision"><Path d="M2 3V17H22V3H2Z" fill="currentColor"/><Path d="M6.24395 20.9592C8.05274 20.337 9.9877 20 12 20C14.0123 20 15.9473 20.337 17.756 20.9592L18.4653 21.2032L18.9532 19.7847L18.2439 19.5408C16.2807 18.8655 14.181 18.5 12 18.5C9.81899 18.5 7.71928 18.8655 5.75605 19.5408L5.04683 19.7847L5.53473 21.2032L6.24395 20.9592Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTelevision;
